/*
 * @Author: 刘小博
 * @Date: 2023-02-17 14:47:35
 * @LastEditTime: 2024-01-16 17:19:48
 * @LastEditors: 肖玲
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\intelligentize-report\industry-data\modules\industryDataCoverRouter.js
 * 行业数据覆盖
 */
const industryDataCoverRouter = [
  //行业数据覆盖
  {
    path: '/intelligenceReports/industry-data/coverage-rate/:cls',
    name: 'intelligenceReportsIndustryDataCoverageRate',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsIndustryDataCoverageRate" */
        // '@/views/intelligenceReports/industryData/coverageRate.vue'
        '@/views/intelligentize-report/industry-data/industry-data-cover/cover/Page.vue'
      ),
    // meta: {SecondaryMenu:'',//二级菜单
    //   title: '终端覆盖分析'
    // }
    meta: {
      SecondaryMenu: '行业数据覆盖', //二级菜单
      title: '医疗覆盖率'
    }
  },
  // 未覆盖数列表
  {
    path: '/intelligenceReports/industry-data/not-cover-count/:cls',
    name: 'intelligenceReportsIndustryDataNotCoverCount',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsIndustryDataNotCoverCount" */
        // '@/views/intelligenceReports/industryData/notCoverCount.vue'
        '@/views/intelligentize-report/industry-data/industry-data-cover/cover/no-cover/Page.vue'
      ),
    meta: {
      SecondaryMenu: '行业数据覆盖', //二级菜单
      title: '未覆盖终端明细',
      breadcrumb: {
        1: {
          title: '零售覆盖率',
          name: 'intelligenceReportsIndustryDataCoverageRate'
        },
        2: {
          title: '医疗覆盖率',
          name: 'intelligenceReportsIndustryDataCoverageRate'
        },
        3: {
          title: '基层覆盖率',
          name: 'intelligenceReportsIndustryDataCoverageRate'
        },
        4: {
          title: '连锁覆盖率',
          name: 'intelligenceReportsIndustryDataCoverageRate'
        },
        5: {
          title: '商业覆盖率',
          name: 'intelligenceReportsIndustryDataCoverageRate'
        }
      }
    }
  },
  // 未覆盖数详情
  {
    path: '/intelligenceReports/industry-data/not-cover-count-detail/:third_platform_id/:cls',
    name: 'intelligenceReportsIndustryDataNotCoverCountDetail',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsIndustryDataNotCoverCountDetail" */
        // '@/views/intelligenceReports/industryData/notCoverCountDetail.vue'
        '@/views/intelligentize-report/industry-data/industry-data-cover/cover/no-cover/Details.vue'
      ),
    meta: {
      SecondaryMenu: '行业数据覆盖', //二级菜单
      title: '零售详情',
      breadcrumb: {
        1: [
          {
            title: '零售覆盖率',
            name: 'intelligenceReportsIndustryDataCoverageRate'
          },
          {
            title: '未覆盖终端明细',
            name: 'intelligenceReportsIndustryDataNotCoverCount'
          }
        ],
        2: [
          {
            title: '医疗覆盖率',
            name: 'intelligenceReportsIndustryDataCoverageRate'
          },
          {
            title: '未覆盖终端明细',
            name: 'intelligenceReportsIndustryDataNotCoverCount'
          }
        ],
        3: [
          {
            title: '基层覆盖率',
            name: 'intelligenceReportsIndustryDataCoverageRate'
          },
          {
            title: '未覆盖终端明细',
            name: 'intelligenceReportsIndustryDataNotCoverCount'
          }
        ],
        4: [
          {
            title: '连锁覆盖率',
            name: 'intelligenceReportsIndustryDataCoverageRate'
          },
          {
            title: '未覆盖终端明细',
            name: 'intelligenceReportsIndustryDataNotCoverCount'
          }
        ],
        5: [
          {
            title: '商业覆盖率',
            name: 'intelligenceReportsIndustryDataCoverageRate'
          },
          {
            title: '未覆盖终端明细',
            name: 'intelligenceReportsIndustryDataNotCoverCount'
          }
        ]
      }
    }
  }
]
export default industryDataCoverRouter
